var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "registerForm",
        staticClass: "sign-up",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onRegister.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                !_vm.hideTitle
                  ? _c("h2", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("login.registerTitle"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.registerResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.registerResponse.message,
                        type: _vm.registerResponse.type
                      },
                      on: {
                        close: function($event) {
                          _vm.registerResponse.message = ""
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "firstname",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                name: "firstname",
                                placeholder: _vm.$t("forms.labels.firstname"),
                                label: _vm.$t("forms.labels.firstname"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.registerForm.firstName,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "firstName", $$v)
                                },
                                expression: "registerForm.firstName"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "lastname",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                name: "lastname",
                                placeholder: _vm.$t("forms.labels.lastname"),
                                label: _vm.$t("forms.labels.lastname"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.registerForm.lastName,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "lastName", $$v)
                                },
                                expression: "registerForm.lastName"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  ref: "registerEmail",
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "email",
                    rules: "required|email",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      email: _vm.$t("forms.errors.emailInvalid")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "email",
                                name: "email",
                                autocomplete: "email",
                                placeholder: _vm.$t("forms.labels.email"),
                                label: _vm.$t("forms.labels.email"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.registerForm.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "email", $$v)
                                },
                                expression: "registerForm.email"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "password",
                    rules: "required|complexpw",
                    vid: "password",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      complexpw: _vm.$t("forms.errors.password")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                name: "password",
                                autocomplete: "new-password",
                                placeholder: _vm.$t("forms.labels.password"),
                                label: _vm.$t("forms.labels.password"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.registerForm.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "password", $$v)
                                },
                                expression: "registerForm.password"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "confirm",
                    vid: "confirm",
                    rules: "required|confirmed:password",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      confirmed: _vm.$t("forms.errors.passwordMatch")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                name: "password-repeat",
                                autocomplete: "new-password",
                                placeholder: _vm.$t(
                                  "forms.labels.passwordRepeat"
                                ),
                                label: _vm.$t("forms.labels.passwordRepeat"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.registerForm.confirm,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "confirm", $$v)
                                },
                                expression: "registerForm.confirm"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _vm.showPhone
                  ? _c("ValidationProvider", {
                      staticClass: "input-wrapper",
                      attrs: {
                        name: "phone",
                        rules: "required|phone",
                        tag: "div",
                        customMessages: {
                          required: _vm.$t("forms.errors.fieldEmpty"),
                          phone: _vm.$t("forms.errors.phone")
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              var invalid = ref.invalid
                              var validated = ref.validated
                              return [
                                _c("FormInput", {
                                  attrs: {
                                    type: "tel",
                                    name: "phone",
                                    placeholder: _vm.$t("forms.labels.phone"),
                                    label: _vm.$t("forms.labels.phone"),
                                    error: errors.length > 0,
                                    disabled: _vm.disabled,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.registerForm.phoneNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.registerForm,
                                        "phoneNumber",
                                        $$v
                                      )
                                    },
                                    expression: "registerForm.phoneNumber"
                                  }
                                }),
                                _vm._v(" "),
                                invalid && validated
                                  ? _c("span", {
                                      staticClass: "input-error",
                                      domProps: { innerHTML: _vm._s(errors[0]) }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "additional-info",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.$t("login.phoneHint"))
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasFeature("FEATURE_NEWSLETTER_REGISTRATION")
                  ? _c(
                      "FormInputCheckbox",
                      {
                        attrs: {
                          name: "newsletter",
                          value: "newsletter",
                          immediate: "",
                          disabled: _vm.disabled
                        },
                        model: {
                          value: _vm.registerForm.subscribedToNewsletter,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.registerForm,
                              "subscribedToNewsletter",
                              $$v
                            )
                          },
                          expression: "registerForm.subscribedToNewsletter"
                        }
                      },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("login.newsletterLabel"))
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  attrs: {
                    rules: { required: { allowFalse: false } },
                    name: "checkTerms",
                    tag: "div",
                    customMessages: { required: _vm.$t("login.errorTerms") }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var invalid = ref.invalid
                          var errors = ref.errors
                          var validated = ref.validated
                          return [
                            _c(
                              "FormInputCheckbox",
                              {
                                attrs: {
                                  name: "terms",
                                  value: "checkTerms",
                                  required: "",
                                  immediate: "",
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.registerForm.checkTerms,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "checkTerms",
                                      $$v
                                    )
                                  },
                                  expression: "registerForm.checkTerms"
                                }
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("login.termsLabel")
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("login.registerButton"),
                    disabled: _vm.disabled
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }